




























































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class AiyyLeftNav extends Vue {
  @Prop()
  private cParent: any;
  @Prop()
  private cChild: any;
  private ifOpen: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private triggerParent(parent) {
    this.ifOpen[parent] = !this.ifOpen[parent];
    this.$forceUpdate();
  }
  /**
   * @description 提示暂未开放
   */
  private notOpen() {
    this.$message.warning("对不起，目前该功能暂未开放");
  }
  private mounted() {
    if (this.cParent) {
      this.ifOpen[this.cParent] = true;
      this.$forceUpdate();
    }
  }
}
